import React from "react";

/** Visor PDF nativo; Fit + page-width para no cortar laterales en mobile. */
export default function RevistaPdfNative({ pdfUrl, title }) {
  const join = pdfUrl.includes("#") ? "&" : "#";
  const src = `${pdfUrl}${join}toolbar=1&navpanes=0&scrollbar=1&view=Fit&zoom=page-width`;
  return (
    <div className="w-full h-full min-h-0 min-w-0 overflow-auto overscroll-contain bg-[#525659]">
      <iframe
        title={title || "Conexión Siete"}
        src={src}
        className="block w-full h-full min-h-full border-0"
        style={{ maxWidth: "100%" }}
      />
    </div>
  );
}
